/* Simple offcanvas controller (button + backdrop)
  - Uses `.bn-navbar-toggler` button and `.bn-offcanvas-backdrop`
   - Handles ESC, backdrop click, focus trap, and resize behavior
*/
(function(){
  const MOBILE_BP = 992;
    let backdrop = document.querySelector('.bn-offcanvas-backdrop');

function waitForNavbar(callback) {

        const timer = setInterval(() => {

            const offcanvas = document.getElementById("bn-navbar-collapse");
            const toggler = document.querySelector(".bn-navbar-toggler");

            if (offcanvas && toggler) {
                clearInterval(timer);
                callback(offcanvas, toggler);
            }

        }, 100);

    }

    waitForNavbar(function (offcanvas, toggler) {
  // Top-level labels that should act as accordions in mobile view
   const ACCORDION_LABELS = ['About Company','Services','Technologies','Industries'];
  const navList = offcanvas.querySelector('.bn-navbar-nav');

  function sanitizeText(txt){ return (txt || '').replace(/\s+/g,' ').trim(); }

  function closestElement(el, selector){
    while(el && el.nodeType !== 1) el = el.parentNode;
    return el ? el.closest(selector) : null;
  }

  // create backdrop dynamically and append to end of body
  function createBackdrop(){
    if(backdrop && document.body.contains(backdrop)) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'bn-offcanvas-backdrop';
    backdrop.tabIndex = -1;
    backdrop.setAttribute('aria-hidden','true');
    backdrop.hidden = true;
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', function(){ if(isOpen()) close(); });
    return backdrop;
  }

  // Add/remove accordion classes dynamically for top-level items on mobile
  function syncAccordions(){
    if(!navList) return;
    const items = Array.from(navList.children).filter(n=> n.classList && n.classList.contains('bn-nav-item'));
    if(isMobile()){
      // ensure nested mega-menu sections are not treated as accordions
      offcanvas.querySelectorAll('.bn-mega-menu-section').forEach(s=> s.classList.remove('accordion','is-open'));
      items.forEach(item=>{
        const link = item.querySelector('.bn-nav-link');
        const label = link ? sanitizeText(link.textContent) : '';
        if(ACCORDION_LABELS.includes(label)){
          item.classList.add('accordion');
          if(link){ link.setAttribute('role','button'); link.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false'); link.tabIndex = 0; }
        } else {
          item.classList.remove('accordion','is-open');
          if(link){ link.removeAttribute('role'); link.removeAttribute('aria-expanded'); link.removeAttribute('tabindex'); }
        }
      });
    } else {
      // desktop: remove accordion classes and close any open panels
      items.forEach(item=>{
        item.classList.remove('accordion','is-open');
        const link = item.querySelector('.bn-nav-link');
        if(link){ link.removeAttribute('role'); link.removeAttribute('aria-expanded'); link.removeAttribute('tabindex'); }
      });
    }
  }

  function closeOtherAccordions(current){
    if(!navList) return;
    Array.from(navList.children).forEach(item=>{
      if(item === current) return;
      if(item.classList && item.classList.contains('accordion') && item.classList.contains('is-open')){
        item.classList.remove('is-open');
        const l = item.querySelector('.bn-nav-link'); if(l) l.setAttribute('aria-expanded','false');
      }
    });
  }

  let prevFocus = null;

  function isOpen(){ return offcanvas.classList.contains('is-open'); }
  function isMobile(){ return window.innerWidth < MOBILE_BP; }

  function getFocusable(container){
    return Array.from(container.querySelectorAll('a,button,input,textarea,select,[tabindex]:not([tabindex="-1"])')).filter(el=>!el.disabled && el.offsetParent!==null);
  }

  function open(){
    prevFocus = document.activeElement;
    offcanvas.classList.add('is-open');
    offcanvas.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('bn-offcanvas-open');
    document.body.style.overflow = 'hidden';
    const b = createBackdrop();
    if(b){ b.classList.add('is-active'); b.hidden = false; }
    if(toggler) { toggler.setAttribute('aria-pressed','true'); toggler.setAttribute('aria-expanded','true'); }
    // focus first focusable inside offcanvas
    const focusable = getFocusable(offcanvas);
    if(focusable.length) focusable[0].focus();
    document.addEventListener('keydown', trapTab);
  }

  function close(){
    // remove keyboard trap first
    document.removeEventListener('keydown', trapTab);

    // Move focus out of the offcanvas BEFORE setting aria-hidden so we
    // don't hide a focused descendant from assistive technology.
    if(prevFocus && typeof prevFocus.focus === 'function'){
      try { prevFocus.focus(); } catch(e) { /* ignore */ }
    } else if(toggler && typeof toggler.focus === 'function'){
      try { toggler.focus(); } catch(e) { /* ignore */ }
    }

    // hide the offcanvas
    offcanvas.classList.remove('is-open');
    offcanvas.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('bn-offcanvas-open');
    document.body.style.overflow = '';

    if(backdrop) {
      backdrop.classList.remove('is-active');
      setTimeout(()=>{
        if(backdrop && backdrop.parentNode){ backdrop.parentNode.removeChild(backdrop); }
        backdrop = null;
      }, 260);
    }

    if(toggler) { toggler.setAttribute('aria-pressed','false'); toggler.setAttribute('aria-expanded','false'); }

    // clear saved focus
    prevFocus = null;
  }

  function trapTab(e){
    if(e.key !== 'Tab') return;
    const focusable = getFocusable(offcanvas);
    if(!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if(e.shiftKey){ if(document.activeElement === first){ e.preventDefault(); last.focus(); } }
    else { if(document.activeElement === last){ e.preventDefault(); first.focus(); } }
  }


  // toggler button click
  toggler.addEventListener('click', function(){
    if(isOpen()) close(); else open();
  });

  // ESC closes
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && isOpen()) close(); });

  // on resize: if leaving mobile, ensure offcanvas is closed
  window.addEventListener('resize', function(){ if(!isMobile() && isOpen()){ close(); } syncAccordions(); });

  // initialize ARIA
  offcanvas.setAttribute('aria-hidden', 'true');
  if(toggler) toggler.setAttribute('role', 'button');

  // initialise accordions state now
  syncAccordions();
  // Footer is statically bound in HTML; dynamic syncing removed intentionally.

  // click delegation: toggle top-level accordion items
  offcanvas.addEventListener('click', function(e){
    if(!isMobile()) return;
    const link = closestElement(e.target, '.bn-nav-link');
    if(!link) return;
    const item = link.closest('.bn-nav-item');
    if(item && item.classList.contains('accordion')){
      e.preventDefault();
      const wasOpen = item.classList.contains('is-open');
      if(wasOpen){ item.classList.remove('is-open'); link.setAttribute('aria-expanded','false'); }
      else { closeOtherAccordions(item); item.classList.add('is-open'); link.setAttribute('aria-expanded','true'); }
    }
  });

  // keyboard support for accordion toggles (Enter / Space)
  offcanvas.addEventListener('keydown', function(e){
    if(!isMobile()) return;
    if(e.key !== 'Enter' && e.key !== ' ') return;
    const target = closestElement(e.target, '.bn-nav-link');
    if(!target) return;
    const item = target.closest('.bn-nav-item');
    if(item && item.classList.contains('accordion')){
      e.preventDefault();
      const wasOpen = item.classList.contains('is-open');
      if(wasOpen){ item.classList.remove('is-open'); target.setAttribute('aria-expanded','false'); }
      else { closeOtherAccordions(item); item.classList.add('is-open'); target.setAttribute('aria-expanded','true'); }
    }
  });
 });

})();



